import { useContext } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import heroImage from "../assets/img/hero-image.png";
import { UserContext } from "../context/userContext";

function Navigasi(props) {
  let navigate = useNavigate();
  const [state, dispatch] = useContext(UserContext);

  if (state.user.status === "admin") {
    navigate("/admin");
  }

  const logout = () => {
    dispatch({
      type: "LOGOUT",
    });
    navigate("/");
  };

  return (
    <Navbar
      bg="light"
      expand="lg"
      className="bg-transparent navbar-dark"
      style={{ padding: 16 }}
    >
      <Container fluid>
        <Link to="/user" className="d-flex align-items-center">
          <img
            src={heroImage}
            alt="Logo"
            style={{ marginRight: 24, width: 60 }}
          />
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="align-items-center">
            <Link
              to="/complain-user"
              className={
                "link-navigasi text-secondary " +
                (props.active === "complain-user" ? "active" : "")
              }
            >
              Complain
            </Link>
            <Link
              to="/my-profile"
              className={
                "link-navigasi text-secondary " +
                (props.active === "myProfile" ? "active" : "")
              }
            >
              Profile
            </Link>
            <Nav.Link onClick={logout} className="link-navigasi text-secondary">
              Logout
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigasi;
